import Realtime from '@/components/Realtime';

const RealtimePage = () => {
  return <Realtime />;
};

export default RealtimePage;
